import { Flex, Title } from '@mantine/core';
import { UserBreadcrumbs, UserCreate } from '@features/user';
import { useBreadcrumbs } from '@shared/lib';
import { useEffect } from 'react';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Создание пользователя', 'Создание нового пользователя');
}

export const UserCreatePage = () => {
  const context = useBreadcrumbs();

  useEffect(() => {
    if (!context) {
      return;
    }

    context.setBreadcrumb(<UserBreadcrumbs subPage='Новый пользователь' />);

    return () => {
      context.clearBreadcrumb();
    };
  }, []);

  return (
    <Flex gap={32} direction='column' flex={1} w='100%' maw={1070}>
      <Title order={3}>Новый пользователь</Title>

      <UserCreate />
    </Flex>
  );
};
